'use strict'

import moment from 'moment'

import css from './ums-order-card.styles.scss'
import template from './ums-order-card.template.pug'

export class OrderCardController {
  constructor($mdDialog, $mdToast) {
    'ngInject'
    Object.assign(this, { $mdDialog, $mdToast })
  }

  showTracking() {
    const trackingDialog = this.$mdDialog.trackingDialog({
      locals: {
        tracking: this.order.tracking,
        orderNo: this.order.no,
      },
    })
    this.$mdDialog.show(trackingDialog)
  }

  download() {
    console.log(this.customer)
    this.customer.getDocumentPdf(this.order.archiveRef, 'Lieferschein_' + this.order.no)
  }

  isBefore() {
    const comparator = moment(this.order.taskDate).endOf('day')
    const today = moment().endOf('day')
    return today.diff(comparator) < 0
  }

  hideTracking() {
    this.$mdDialog.hide()
  }

  cancel() {
    const confirm = this.$mdDialog
      .confirm()
      .title(`Auftrag ${this.order.no} wirklich stornieren?`)
      .textContent('Diese Aktion kann nicht rückgängig gemacht werden.')
      .ok('Stornieren')
      .cancel('Abbrechen')

    this.$mdDialog.show(confirm).then(() => {
      this.customer
        .cancelOrder(this.order)
        .then(() => this.onCancelled({ order: this.order }))
        .catch(() => {
          const toast = this.$mdToast
            .simple()
            .textContent('Stornierung fehlgeschlagen.')
            .action('OK')
            .position('bottom')
            .hideDelay(10000)
          this.$mdToast.show(toast)
        })
    })
  }
}

export const umsOrderCard = {
  template: template({ css }),
  bindings: {
    order: '<',
    customer: '<',
    tasksite: '<',
    onCancelled: '&',
  },
  controller: OrderCardController,
}



// WEBPACK FOOTER //
// ./app/orders/components/order-card/ums-order-card.component.js